import React, { useState, useEffect } from "react";
import Layout from "../components/Layout";

const Form = () => {
    const [substations, setSubstations] = useState([]); // Подстанции
    const [networks, setNetworks] = useState([]); // Сети
    const [formData, setFormData] = useState({
        type: "substation", // Тип (подстанция/сеть)
        formsubstationId: "", // ID подстанции
        formnetworkId: "", // ID сети
        description: "", // Описание действий
    });

    // Получение данных из API
    useEffect(() => {
        const token = localStorage.getItem("token");
        fetch("/api/substation", {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
            .then((res) => res.json())
            .then((data) => setSubstations(data))
            .catch((err) => console.error("Ошибка загрузки подстанций:", err));

        fetch("/api/network", {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
            .then((res) => res.json())
            .then((data) => setNetworks(data))
            .catch((err) => console.error("Ошибка загрузки сетей:", err));
    }, []);

    // Генерация текущей даты
    // const getCurrentDateTime = () => {
    //     const now = new Date();
    //     const hours = String(now.getHours()).padStart(2, '0');
    //     const minutes = String(now.getMinutes()).padStart(2, '0');
    //     const day = String(now.getDate()).padStart(2, '0');
    //     const month = String(now.getMonth() + 1).padStart(2, '0');
    //     const year = now.getFullYear();
    //     return `${hours}:${minutes} ${day}.${month}.${year}`;
    // };

    // Обработка изменения данных формы
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    // Обработка выбора типа (подстанция или сеть)
    const handleTypeSelect = (type) => {
        setFormData({ ...formData, type, formsubstationId: "", formnetworkId: "" }); // Сбрасываем ID при смене типа
    };

    // Отправка данных формы
    const handleSubmit = (e) => {
        e.preventDefault();

        // Заменяем пустые строки на null перед отправкой
        const dataToSend = {
            ...formData,
            formsubstationId: formData.formsubstationId === "" ? null : formData.formsubstationId,
            formnetworkId: formData.formnetworkId === "" ? null : formData.formnetworkId,
            // completionDate: getCurrentDateTime(),
        };

        fetch("/api/form", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
            body: JSON.stringify(dataToSend),
        })
            .then((res) => res.json())
            .then((data) => {
                alert("Форма успешно отправлена!");
                setFormData({
                    type: "substation",
                    formsubstationId: "",
                    formnetworkId: "",
                    description: "",
                });
            })
            .catch((err) => console.error("Ошибка отправки формы:", err));
    };

    return (
        <Layout>
            <div className="addform">
                <div className="container">
                    <h3 className="addform__title">Анкета</h3>
                    <form className="addform-form" onSubmit={handleSubmit}>
                        <div className="addform-form__btns">
                            <button
                                className={formData.type === "substation" ? "btns btns--active" : "btns"}
                                type="button"
                                onClick={() => handleTypeSelect("substation")}
                            >
                                Подстанция
                            </button>
                            <button
                                className={formData.type === "network" ? "btns btns--active" : "btns"}
                                type="button"
                                onClick={() => handleTypeSelect("network")}
                            >
                                Сеть
                            </button>
                        </div>
                        <div className="addform-form__column column">
                            <label className="column__title">
                                {formData.type === "substation" ? "Подстанция:" : "Сеть:"}
                            </label>
                            <select
                                className="column__select"
                                name={formData.type === "substation" ? "formsubstationId" : "formnetworkId"}
                                value={formData.type === "substation" ? formData.formsubstationId : formData.formnetworkId}
                                onChange={handleChange}
                                required
                            >
                                <option value="">Выберите...</option>
                                {(formData.type === "substation" ? substations : networks).map(
                                    (item) => (
                                        <option key={item.id} value={item.id}>
                                            {item.name}
                                        </option>
                                    )
                                )}
                            </select>
                        </div>
                        {/* <div className="addform-form__column column">
                            <label className="column__title">Дата выполнения:</label>
                            <input
                                className="column__date"
                                type="date"
                                name="completionDate"
                                value={formData.completionDate}
                                onChange={handleChange}
                                required
                            />
                        </div> */}
                        <div className="addform-form__column column">
                            <label className="column__title">Описание действий:</label>
                            <textarea
                                className="column__textarea"
                                name="description"
                                value={formData.description}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <button className="addform-form__submit" type="submit">Отправить</button>
                    </form>
                </div>
            </div>
        </Layout>
    );
};

export default Form;
